export function toAddressSelectGoogleMapsPlaceItem({ placeId, text }) {
  return { label: text.text, value: placeId }
}

export function toAddressSelectGoogleMapsPlaceItems(items) {
  return items.map(toAddressSelectGoogleMapsPlaceItem)
}
